/**
 * Personagens em Rive (Faces e Gota de porcelana). Aprovados pelo Igor em
 * 05/10/2026 depois de ver no Fold: ligados no app instalado e na web. A chave
 * continua como freio: `VITE_RIVE_CHARACTERS=false` no build volta às camadas,
 * e no aparelho `secretario.motor = camadas` (ou `rive`) força um dos dois.
 */
export function riveOn(): boolean {
  try {
    const forced = localStorage.getItem('secretario.motor');
    if (forced === 'camadas') return false;
    if (forced === 'rive') return true;
  } catch {
    /* sem armazenamento: vale a chave do build */
  }
  return import.meta.env.VITE_RIVE_CHARACTERS !== 'false';
}
